<template>
  <main class="ban container">
    <div>
      <div style="height: 200px">
        <h3>채팅 차단 단어 - {{ $router.param }}</h3>
        <textarea style="width: 100%; height: 140px" v-model="filters"></textarea>
      </div>
      <div>
        <button class="btn btn-primary" style="width: 100%" @click="setFiltersWord">Submit</button>
      </div>
    </div>
    <div class="mt-4">
      <h3>채팅 차단 사용자</h3>
      <banned-watchers show-message="true"></banned-watchers>
    </div>
    <div>
      <h3>Chat CSS</h3>
      <textarea style="width: 100%; height: 140px" v-model="tmpCss" @input="chageCss(tmpCss)"></textarea>
    </div>
  </main>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import BannedWatchers from '@/components/chat/BannedWatchers/'
// import l from '@/vendor/logger'

export default {
  name: 'Ban',

  created () {
    this.$store.dispatch('setMode', this.$route.params.mode.toUpperCase())
    this.$store.dispatch('chatOption/bindBannedWatchers')
    this.$store.dispatch('chatOption/bindFilteringWords')
    this.$store.dispatch('chatOption/bindChatCss')
    this.$store.commit('room/setRoomType', 'CHAT_CONFIG')
  },

  mounted () {
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  data () {
    return {
      filters: '',
      tmpCss: ''
    }
  },

  methods: {
    unbind () {
      this.$store.dispatch('chatOption/unbindBannedWatchers')
      this.$store.dispatch('chatOption/unbindFilteringWords')
      this.$store.dispatch('chatOption/unbindChatCss')
    },
    getFiltersWord () {
      // this.$store.dispatch('bannedWatchers/getFiltersWord')
    },
    setFiltersWord () {
      this.$store.dispatch('chatOption/setFiltersWord', { filters: this.filters, mode: this.$route.params.mode.toUpperCase() })
    },
    filteringWordsValue () {
      return this.words ? this.words : ''
    },
    chageCss (css) {
      this.$store.dispatch('chatOption/setChatCss', css)
    }
  },

  watch: {
    filteringWords () {
      if (this.filteringWords) {
        this.filters = `${this.words}`
      } else {
        this.filters = ''
      }
    },
    chatCss () {
      if (this.chatCss) {
        this.tmpCss = this.chatCss
      } else {
        this.tmpCss = ''
      }
    }
  },

  computed: {
    ...mapState('chatOption', [
      'filteringWords'
    ]),
    ...mapGetters('chatOption', [
      'words', 'chatCss'])
  },

  components: {
    BannedWatchers
  }
}
</script>

<style scoped>

</style>
